import { defineStore } from 'pinia'

export const useSessionStore = defineStore('session', {
  state: () => ({
    laravel_session: '',
    domain: '',
    lang: 'en'
  }),
  actions: {
    setSession(laravel_session?: string) {
      if (laravel_session) {
        this.laravel_session = laravel_session
      }
    },
    setLang(lang: string) {
      this.lang = lang
    }
  }
})
